export interface UltraPlonkProof {
  proof: string;
}

export interface UltraPlonkVk {
  vk: string;
}

export interface UltraPlonkPubs {
  pubs: string;
}
